export * from '@primeuix/themes/lara/inputnumber';
export { default } from '@primeuix/themes/lara/inputnumber';
